
import { CaseStudyContent } from "./card/CaseStudyContent";
import { TestimonialSection } from "./card/TestimonialSection";
import { getPatternStyles } from "./patterns/patternStyles";

interface CaseStudyResult {
  text: string;
}

export interface CaseStudyProps {
  id?: string;
  title: string;
  industry: string;
  companyType?: string;
  challenge: string;
  solution: string;
  results: CaseStudyResult[];
  testimonial?: {
    quote: string;
    author: string;
    role?: string;  // Made optional to match actual usage
  };
  cta?: {
    text: string;
    link: string;
  };
  tags?: string[];
  redactedName?: string;
}

export const CaseStudyCard = ({
  id,
  title,
  industry,
  companyType,
  challenge,
  solution,
  results,
  testimonial,
  cta,
  tags,
  redactedName
}: CaseStudyProps) => {
  // Get the pattern based on the case study ID and industry
  const pattern = getPatternStyles(id, industry);
  
  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-lg transition-shadow duration-300">
      <div className="md:grid md:grid-cols-3 gap-6">
        <CaseStudyContent 
          industry={industry}
          companyType={companyType}
          title={title}
          challenge={challenge}
          results={results}
          tags={tags}
          cta={cta}
          redactedName={redactedName}
        />
        
        {testimonial && (
          <TestimonialSection 
            testimonial={testimonial} 
            pattern={pattern}
            id={id}
          />
        )}
      </div>
    </div>
  );
};
